<template>
  <component
    v-if="component_id"
    :is="getDynamicComponent(component.type)"
    :component="component"
    :parent_key="parent_key"
    :section_key="section_key"
    :grid_key="grid_key"
    :grid_layout="grid_layout"
    :cell_order="cell_order"
    >
    <slot/>
  </component>
</template>

<script>
import {
  WIDGET,
  CELL,
  GRID,
  SECTION,
  SECTION_PAGE_PRODUCT,
  SECTION_PAGE_PRODUCT_ITEM,
  SECTION_PAGE_ALBUM,
  SECTION_PAGE_CONTENT,
  SECTION_PAGE_ALBUM_ITEM,
  SECTION_PAGE_CONTENT_ITEM,
  SECTION_PAGE_TERMS_CONDITION,
  SECTION_PAGE_PRODUCT_BRAND,
  SECTION_PAGE_INFORM_PAYMENT,
  SECTION_PAGE_ONLINE_PAYMENT,
  SECTION_PAGE_ORDER_TRACKING,
  SECTION_PAGE_CONTACT,
  SECTION_PAGE_FORM_ITEM,
  SECTION_PAGE_FAQ,
  SECTION_PAGE_EVENT_CALENDAR,
  SECTION_PAGE_EVENT_CALENDAR_ITEM,
  SECTION_PAGE_POLICY,
  SECTION_PAGE_QUOTATION_FORM_ITEM,
  SECTION_PAGE_GIFTCARD,
  SLIDE_SECTION,
  SLIDE_PAGE,
} from "@model/components/componentMeta.model";

const components = {
  // default component
  NotExist: () => import("./NotExist"),
  // groupping component
  [SECTION.type]: () => import("./Section"),
  [SECTION_PAGE_ALBUM.type]: () => import("./SectionPageAlbum/SectionPageAlbum.vue"),
  [SECTION_PAGE_CONTENT.type]: () => import("./SectionPageContent/SectionPageContent.vue"),
  [SECTION_PAGE_CONTENT_ITEM.type]: () => import("./SectionPageContentItem/SectionPageContentItem.vue"),
  [SECTION_PAGE_ALBUM.type]: () => import("./SectionPageAlbum/SectionPageAlbum.vue"),
  [SECTION_PAGE_ALBUM_ITEM.type]: () => import("./SectionPageAlbumItem/SectionPageAlbumItem.vue"),
  [SECTION_PAGE_TERMS_CONDITION.type]: () => import("./SectionPageTermsCondition/SectionPageTermsCondition.vue"),
  [SECTION_PAGE_PRODUCT.type]: () => import("./SectionPageProduct/SectionPageProduct.vue"),
  [SECTION_PAGE_PRODUCT_ITEM.type]: () => import("./SectionPageProductItem/SectionPageProductItem.vue"),
  [SECTION_PAGE_PRODUCT_BRAND.type]: () => import("./SectionPageProductBrand/SectionPageProductBrand.vue"),
  [SECTION_PAGE_INFORM_PAYMENT.type]: () => import("./SectionPageInformpayment/SectionPageInformpayment.vue"),
  [SECTION_PAGE_ONLINE_PAYMENT.type]: () => import("./SectionPageOnlinePayment/SectionPageOnlinePayment.vue"),
  [SECTION_PAGE_ORDER_TRACKING.type]: () => import("./SectionPageOrderTracking/SectionPageOrderTracking.vue"),
  [SECTION_PAGE_CONTACT.type]: () => import("./SectionPageContact/SectionPageContact.vue"),
  [SECTION_PAGE_FORM_ITEM.type]: () => import("./SectionPageFormItem/SectionPageFormItem.vue"),
  [SECTION_PAGE_FAQ.type]: () => import("./SectionPageFAQ/SectionPageFAQ.vue"),
  [SECTION_PAGE_EVENT_CALENDAR.type]: () => import("./SectionPageEventCalendar/SectionPageEventCalendar.vue"),
  [SECTION_PAGE_EVENT_CALENDAR_ITEM.type]: () => import("./SectionPageEventCalendarItem/SectionPageEventCalendarItem.vue"),
  [SECTION_PAGE_POLICY.type]: () => import("./SectionPagePolicy/SectionPagePolicy.vue"),
  [SECTION_PAGE_QUOTATION_FORM_ITEM.type]: () => import("./SectionPageQuotationFormItem/SectionPageQuotationFormItem.vue"),
  [SECTION_PAGE_GIFTCARD.type]: () => import("./SectionPageGiftcard/SectionPageGiftcard.vue"),
  [GRID.type]: () => import("./Grid"),
  [CELL.type]: () => import("./Cell"),
  [WIDGET.prefixType]: () => import("./Widget"),
  [SLIDE_SECTION.type]: () => import("./SlideSection"),
  [SLIDE_PAGE.type]: () => import("./SlidePage")
};
const componentsKey = Object.keys(components);
import { mapGetters } from "vuex";

export default {
  components: {
    ...components,
  },
  computed: {
    ...mapGetters({
      components: "designIframe/metadata/components",
    }),
    component() {
      return this.components[this.component_id];
    },
  },
  methods: {
    getDynamicComponent(key) {
      key = key.search(WIDGET.prefixType) > -1 ? WIDGET.prefixType : key;

      if (componentsKey.indexOf(key) > -1) {
        return key;
      } else {
        return "NotExist";
      }
    },
  },
  props: [
    "component_id",
    "parent_key",
    "section_key",
    "grid_key",
    "grid_layout",
    "cell_order",
  ],
};
</script>

<style>
</style>